import { render, staticRenderFns } from "./WorkHeader.vue?vue&type=template&id=42cb3aaf&scoped=true"
import script from "./WorkHeader.vue?vue&type=script&lang=js"
export * from "./WorkHeader.vue?vue&type=script&lang=js"
import style0 from "./WorkHeader.vue?vue&type=style&index=0&id=42cb3aaf&prod&lang=scss&scoped=true"
import style1 from "./WorkHeader.vue?vue&type=style&index=1&id=42cb3aaf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cb3aaf",
  null
  
)

export default component.exports